import React from 'react';
import { useWebsiteContent } from '../../hooks/useWebsiteContent';
import { whereIShootModel } from '../../utils/localBusiness';

interface ShootLink {
  label: string;
  href: string;
}

function BrowseLinks({ links }: { links: ShootLink[] }) {
  if (links.length === 0) return null;
  if (links.length === 1) {
    return (
      <>
        {' '}Browse the <a href={links[0].href}>{links[0].label}</a> gallery.
      </>
    );
  }
  const last = links[links.length - 1];
  const rest = links.slice(0, -1);
  return (
    <>
      {' '}Browse the {rest.map((link, index) => (
        <React.Fragment key={`${link.href}-${link.label}`}>
          {index > 0 ? ', ' : null}
          <a href={link.href}>{link.label}</a>
        </React.Fragment>
      ))}, and <a href={last.href}>{last.label}</a> galleries.
    </>
  );
}

const WhereIShoot: React.FC = () => {
  const section = whereIShootModel(useWebsiteContent());

  return (
    <section className="where-we-shoot">
      <h2>{section.heading}</h2>
      <p>
        {section.body}
        <BrowseLinks links={section.links} />
      </p>
    </section>
  );
};

export default WhereIShoot;
